<template>
  <div>
    <div>
      <div class="relative inline-block text-left">
        <div>
          <span class="rounded-md shadow-sm">
            <button
              @click="isOpen = !isOpen"
              class="flex items-center rounded-full p-1 text-sm"
              :class="{
                'text-yellow-800 hover:text-yellow-900 bg-yellow-100 ':
                  completedValue.completedFeatures <
                  completedValue.totalFeatures,
                'text-green-400 hover:text-green-600':
                  completedValue.completedFeatures ===
                  completedValue.totalFeatures
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span class="tracking-widest">
                ({{ completedValue.completedFeatures }}/{{
                  completedValue.totalFeatures
                }})
              </span>
            </button>
          </span>
        </div>

        <transition
          enter-active-class="transition ease-out duration-100 transform"
          enter-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75 transform"
          leave-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div
            class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-50 bg-white"
            v-show="isOpen"
          >
            <div class="py-8 px-4">
              <nav class="flex justify-center" aria-label="Progress">
                <ol role="list" class="space-y-6">
                  <li v-for="(feature, index) in features" :key="index">
                    <!-- Complete Step -->
                    <a
                      @click="gotoRoute(feature.routeName)"
                      class="group cursor-pointer"
                    >
                      <span class="flex items-start">
                        <span
                          class="flex-shrink-0 relative h-5 w-5 flex items-center justify-center"
                        >
                          <!-- Heroicon name: solid/check-circle -->
                          <svg
                            v-if="
                              onboardingFlags && onboardingFlags[feature.flag]
                            "
                            class="h-full w-full text-indigo-600 group-hover:text-indigo-800"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <div
                            v-else
                            class="h-2 w-2 bg-gray-300 rounded-full group-hover:bg-gray-400"
                          ></div>
                        </span>
                        <span
                          class="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900"
                          >{{ feature.label }}</span
                        >
                      </span>
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnboardingChecklist",
  data() {
    return {
      isOpen: false,
      features: [
        {
          label: "Chat & Share",
          routeName: "Chat",
          flag: "isChatPageVisited"
        },
        {
          label: "Automated Abandoned carts",
          routeName: "AutomationConfigure",
          flag: "isAutomatedAbandonedVisited"
        },
        {
          label: "Automated Order confirmation",
          routeName: "OrderConfirmation",
          flag: "isAutomatedOrderConfirmationVisited"
        },
        {
          label: "Automated Shipping update",
          routeName: "OrderShippingUpdates",
          flag: "isAutomatedShippingUpdateVisited"
        },
        {
          label: "Automated COD confirmation",
          routeName: "CodOrder",
          flag: "isAutomatedCODOrderConfirmationVisited"
        },
        {
          label: "Loox integration",
          routeName: "LooxHome",
          flag: "isLooxIntegrationVisited"
        }
      ]
    };
  },
  computed: {
    onboardingFlags() {
      const config = this.$store.getters.getConfig;
      if (config) {
        return config.onboardingFlags;
      }
      return {};
    },
    completedValue() {
      const flags = this.onboardingFlags;
      const features = this.features;
      const totalFeatures = features.length;
      let completedFeatures = 0;
      this.features.forEach(feature => {
        if (flags && flags[feature.flag]) {
          completedFeatures = completedFeatures + 1;
        }
      });
      return { totalFeatures, completedFeatures };
    }
  },
  created() {
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropDropdown = false;
        this.isOpen = false;
      }
    },
    gotoRoute(route) {
      this.$router.push({ name: route });
      this.dropDropdown = false;
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
